/**
 * Post-invite login handoff flag (BFP-177).
 * Set when the user leaves `TeamInviteAcceptPage` success step for login;
 * cleared silently on first dashboard load (Editor/Viewer use the inline welcome strip).
 */

export const POST_INVITE_DASHBOARD_WELCOME_SESSION_KEY =
  'brushfire.sensemaker.postInviteDashboardWelcome'

/** URL flag survives subdomain / apex redirects where `sessionStorage` does not. */
export const POST_INVITE_WELCOME_QUERY_PARAM = 'postInviteWelcome'

export function postInviteWelcomeQuery(): string {
  return `${POST_INVITE_WELCOME_QUERY_PARAM}=1`
}

export function markPostInviteWelcomePending(): void {
  sessionStorage.setItem(POST_INVITE_DASHBOARD_WELCOME_SESSION_KEY, '1')
}

/**
 * Intent from sessionStorage (same tab / origin) or `?postInviteWelcome=1` (cross-subdomain).
 */
export function isPostInviteWelcomePending(searchParams?: URLSearchParams): boolean {
  if (
    typeof sessionStorage !== 'undefined' &&
    sessionStorage.getItem(POST_INVITE_DASHBOARD_WELCOME_SESSION_KEY) === '1'
  ) {
    return true
  }
  return searchParams?.get(POST_INVITE_WELCOME_QUERY_PARAM) === '1'
}

export function clearPostInviteWelcomePending(): void {
  sessionStorage.removeItem(POST_INVITE_DASHBOARD_WELCOME_SESSION_KEY)
}
